<template>
    <i-select filterable autofocus size="large" v-model="selected" @input="onChange">
        <i-option v-for="(option, index) in tickets" :value="option.value" :key="index">{{option.label}}</i-option>
    </i-select>
</template>

<script>
    export default {
        name: 'tickets-select',
        props: {
            value: Number,
            exclude: Number,
            exibirQuarentena: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                selected: 0,
                tickets: []
            }
        },
        methods: {
            onChange() {
                this.$emit("input", this.selected);
            }
        },
        async created() {
            this.selected = this.value || 0;
            /**
             * Obtém os tickets que estão em desenvolvimento
             */
            let {data} = await this.$axios.get('ticket/desenvolvimento');

            if (this.exibirQuarentena) {
                let {data: {data: quarentena}} = await this.$axios.get('ticket?status=0');

                data = data.concat(quarentena);
            }

            this.tickets = data
                .filter(o => o.id_ticket !== this.exclude)
                .map(o => ({
                    value: o.id_ticket,
                    label: `${o.id_ticket} - ${o.resumo}`
                }))
        }
    }
</script>
